import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Maintenance = () => {
  return (
    <div className="h-screen flex items-center -mt-10">
      <div className="w-full flex flex-col items-center gap-6">
        <FontAwesomeIcon icon="robot" className="text-6xl" />

        <div className="uppercase font-mono tracking-tighter">
          Manutenção
        </div>

        <button
          className="border rounded py-2 px-4 font-bold hover:bg-slate-50 flex gap-2 items-center"
          onClick={() => window.location.reload()}
        >
          <FontAwesomeIcon icon="arrows-rotate" />
          <span>Atualizar página</span>
        </button>
      </div>
    </div>
  );
};

export default Maintenance;
